import { IonImg } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import EnodeInitHeader from '../components/ENodeInitHeader'

interface Props {
	goForward: () => void
}

const SafeChargingInfo: React.FC<Props> = ({ goForward }) => {
	const { t } = useTranslation('pages_enodeInit')

	return (
		<div className='flex flex-col h-full justify-between px-4 py-6'>
			<div className='flex flex-col gap-8'>
				<div className='flex items-center gap-4'>
					<EnodeInitHeader position={2} total={5} text={t('safeChargingInfo.otsikko')} />
					<span className='text-xl tracking-wide font-semibold text-gray-900 dark:text-white'>
						{t('safeChargingInfo.otsikko')}
					</span>
				</div>

				<div className='flex justify-center w-full py-2'>
					<IonImg
						className='h-44 object-contain drop-shadow-md'
						src={'./assets/battery_1_bar.png'}
					/>
				</div>

				<div className='flex flex-col gap-6 text-center px-2'>
					<p className='text-[15px] leading-relaxed text-gray-800 dark:text-white/95 font-medium'>
						{t('safeChargingInfo.info1')}
					</p>
					<p className='text-[15px] leading-relaxed text-gray-800 dark:text-white/95 font-medium'>
						{t('safeChargingInfo.info2')}
					</p>
				</div>
			</div>

			<div className='mt-10 mb-2'>
				<Button onClick={goForward}>{t('jatka', { ns: 'common' })}</Button>
			</div>
		</div>
	)
}

export default SafeChargingInfo
